import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import api from 'api/axios';
import ConfirmModal from "../ConfirmModal/ConfirmModal";

const CGHS_CATEGORIES = [
  { value: "Consultation", label: "Consultation" },
  { value: "Diagnostic", label: "Diagnostic" },
  { value: "Dental", label: "Dental" },
  { value: "Implant", label: "Implant" },
];

const CGHS_DENTAL_CLASSIFICATIONS = [
  "Dental Investigation",
  "Dental Biopsy",
  "Dental Procedure",
  "Dentistry",
];

const CghsRateModal = ({ open, onClose, data }) => {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    bgcolor: "background.paper",
    borderRadius: "15px",
    boxShadow: 24,
    p: 4,
  };

  const [_id, setID] = useState("");
  const [procedureName, setProcedureName] = useState("");
  const [cghsCode, setCghsCode] = useState("");
  const [category, setCategory] = useState("");
  const [specialityClassification, setSpecialityClassification] = useState("");
  const [baseRate, setBaseRate] = useState("");
  const [superSpecialityApplicable, setSuperSpecialityApplicable] =
    useState(false);
  const [wardAdjustable, setWardAdjustable] = useState(false);
  const [status, setStatus] = useState("ACTIVE");
  const [disabled, setDisabled] = useState(true);
  const [isApiLoading, setIsApiLoading] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);

  const enableBtn = () => setDisabled(false);

  // Prefill on edit
  useEffect(() => {
    if (data && Object.entries(data).length > 0) {
      setID(data?._id || "");
      setProcedureName(data?.procedureName || "");
      setCghsCode(data?.cghsCode || "");
      setCategory(data?.category || "");
      setSpecialityClassification(data?.specialityClassification || "");
      setBaseRate(data?.baseRate != null ? data?.baseRate : "");
      setSuperSpecialityApplicable(data?.superSpecialityApplicable === true);
      setWardAdjustable(data?.wardAdjustable === true);
      setStatus(data?.status || "ACTIVE");
    }
  }, []);

  const handleSubmit = () => {
    try {
      // Basic validation
      if (!procedureName || !cghsCode || !category) {
        toast.error("Procedure Name, CGHS Code and Category are required.");
        return;
      }
      if (!CGHS_DENTAL_CLASSIFICATIONS.includes(specialityClassification)) {
        toast.error("Select the Speciality Classification.");
        return;
      }
      if (baseRate !== "" && !(Number(baseRate) >= 0)) {
        toast.error("Base rate must be zero or more.");
        return;
      }

      setIsApiLoading(true);

      const payload = {
        procedureName,
        cghsCode,
        category,
        specialityClassification,
        baseRate: baseRate === "" ? null : Number(baseRate),
        superSpecialityApplicable,
        wardAdjustable,
        status,
      };

      if (_id) {
        // Update
        api
          .patch(`/admin/update-cghs-rate/${_id}`, payload)
          .then(() => {
            setIsApiLoading(false);
            onClose();
            toast.success("CGHS Rate Updated Successfully!");
          })
          .catch((err) => {
            setIsApiLoading(false);
            toast.error(
              err?.response?.data?.message || "Update failed!"
            );
          });
      } else {
        // Add new
        api
          .post(`/admin/add-cghs-rate`, payload)
          .then(() => {
            setIsApiLoading(false);
            onClose();
            toast.success("CGHS Rate Added Successfully!");
          })
          .catch((err) => {
            setIsApiLoading(false);
            onClose("close");
            toast.error(
              err?.response?.data?.message || "Add failed!"
            );
          });
      }
    } catch (err) {
      setIsApiLoading(false);
      onClose("close");
      toast.error(`Failed to ${_id ? "update" : "add"} CGHS Rate!`);
    }
  };

  const handleDelete = () => {
    api
      .delete(`/admin/delete-cghs-rate/${_id}`)
      .then(() => {
        setIsApiLoading(false);
        onClose();
        toast.success("CGHS Rate Deactivated Successfully!");
      })
      .catch((err) => {
        setIsApiLoading(false);
        toast.error(err?.response?.data?.message || "Delete failed!");
      });
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={() => onClose("close")}
        aria-labelledby="cghs-modal-title"
      >
        <Box sx={style}>
          {/* Header */}
          <Grid
            container
            spacing={2}
            display="flex"
            justifyContent="left"
            sx={{ mb: 3 }}
          >
            <Grid
              item
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
              }}
            >
              <Typography variant="h5" component="h5">
                {_id ? "Edit CGHS Rate" : "Add CGHS Rate"}
              </Typography>

              {/* Delete Button — sirf edit mein dikhega */}
              {_id && (
                <Box
                  onClick={() => setDeleteModal(true)}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "30px",
                    height: "30px",
                    bgcolor: "#FFE6F0",
                    borderRadius: "8px",
                    cursor: "pointer",
                  }}
                >
                  <svg width={25} height={25} viewBox="0 0 25 25" fill="none">
                    <path
                      d="M10.4941 12.5V17.5"
                      stroke="#F51934"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M14.4941 12.5V17.5"
                      stroke="#F51934"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M4.49414 7.5H20.4941"
                      stroke="#F51934"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M6.49414 10.5V18.5C6.49414 20.1569 7.83729 21.5 9.49414 21.5H15.4941C17.151 21.5 18.4941 20.1569 18.4941 18.5V10.5"
                      stroke="#F51934"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M9.49414 5.5C9.49414 4.39543 10.3896 3.5 11.4941 3.5H13.4941C14.5987 3.5 15.4941 4.39543 15.4941 5.5V7.5H9.49414V5.5Z"
                      stroke="#F51934"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </Box>
              )}
            </Grid>
          </Grid>

          {/* Form Fields */}
          <Grid container spacing={3} justifyContent="center">

            {/* Procedure Name */}
            <Grid item sm={12} lg={6} md={6}>
              <TextField
                fullWidth
                type="text"
                label="Procedure Name"
                value={procedureName}
                onChange={(e) => {
                  enableBtn();
                  setProcedureName(e.target.value);
                }}
                size="small"
              />
            </Grid>

            {/* CGHS Code */}
            <Grid item sm={12} lg={6} md={6}>
              <TextField
                fullWidth
                type="text"
                label="CGHS Code"
                value={cghsCode}
                disabled={!!_id} // Edit mein code change na ho
                onChange={(e) => {
                  enableBtn();
                  setCghsCode(e.target.value);
                }}
                size="small"
              />
            </Grid>

            {/* Category */}
            <Grid item sm={12} lg={6} md={6}>
              <FormControl fullWidth size="small">
                <InputLabel>Category</InputLabel>
                <Select
                  value={category}
                  label="Category"
                  onChange={(e) => {
                    enableBtn();
                    setCategory(e.target.value);
                  }}
                >
                  {CGHS_CATEGORIES.map((cat) => (
                    <MenuItem key={cat.value} value={cat.value}>
                      {cat.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* Base Rate */}
            <Grid item sm={12} lg={6} md={6}>
              <TextField
                fullWidth
                type="number"
                label="Base Rate (₹)"
                placeholder="Empty = Unlisted (not configured)"
                helperText="Tier I · NABH · Semi-Private"
                value={baseRate}
                onChange={(e) => {
                  enableBtn();
                  setBaseRate(e.target.value);
                }}
                size="small"
                inputProps={{ min: 0 }}
              />
            </Grid>

            <Grid item sm={12} lg={6} md={6}>
              <FormControl fullWidth size="small" required>
                <InputLabel>Speciality Classification</InputLabel>
                <Select
                  value={
                    CGHS_DENTAL_CLASSIFICATIONS.includes(specialityClassification)
                      ? specialityClassification
                      : ""
                  }
                  label="Speciality Classification"
                  onChange={(e) => {
                    enableBtn();
                    setSpecialityClassification(e.target.value);
                  }}
                >
                  {CGHS_DENTAL_CLASSIFICATIONS.map((value) => (
                    <MenuItem key={value} value={value}>
                      {value}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* Status */}
            <Grid item sm={12} lg={6} md={6}>
              <FormControl fullWidth size="small">
                <InputLabel>Status</InputLabel>
                <Select
                  value={status}
                  label="Status"
                  onChange={(e) => {
                    enableBtn();
                    setStatus(e.target.value);
                  }}
                >
                  <MenuItem value="ACTIVE">ACTIVE</MenuItem>
                  <MenuItem value="INACTIVE">INACTIVE</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item sm={12} lg={6} md={6}></Grid>

            <Grid item sm={12} lg={6} md={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={superSpecialityApplicable}
                    onChange={(e) => {
                      enableBtn();
                      setSuperSpecialityApplicable(e.target.checked);
                    }}
                  />
                }
                label="Super Speciality +15% applies"
              />
            </Grid>
            <Grid item sm={12} lg={6} md={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={wardAdjustable}
                    onChange={(e) => {
                      enableBtn();
                      setWardAdjustable(e.target.checked);
                    }}
                  />
                }
                label="Ward entitlement ±5% applies (IPD)"
              />
            </Grid>
          </Grid>

          {/* Footer Buttons */}
          <Grid
            item
            sm={12}
            lg={12}
            md={12}
            display="flex"
            justifyContent="right"
            sx={{ mt: 3 }}
          >
            <Button
              sx={{
                marginRight: "15px",
                bgcolor: "white",
                border: "1px solid #194AF5",
                color: "#194AF5",
                padding: "0.25rem 1.5rem",
                boxShadow: "none",
                ":hover": {
                  bgcolor: "white",
                  border: "1px solid #194AF5",
                  boxShadow: "none",
                },
              }}
              variant="contained"
              onClick={() => onClose("close")}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              disabled={disabled || isApiLoading}
              onClick={handleSubmit}
              sx={{ padding: "0.25rem 1.5rem", boxShadow: "none" }}
            >
              {isApiLoading ? "Saving..." : "Save"}
            </Button>
          </Grid>

          {/* Delete Confirm Modal */}
          <ConfirmModal
            open={deleteModal}
            type="cghs"
            close={() => setDeleteModal(false)}
            confirm={() => {
              handleDelete();
              setDeleteModal(false);
            }}
          />
        </Box>
      </Modal>
    </div>
  );
};

export default CghsRateModal;